cc.Class({
    extends: cc.Component,

    properties: {
        tileSize: 20,
        gap: 5,
        gphs: cc.Graphics,
        indexLabel: cc.Label
    },

    // example. this.init({data: [1,0,0,0,0,1], index: 1, taxonomy: {reel: 6, row:4}});
    init({ data, index, taxonomy }) {
        this.gphs.clear();

        this.indexLabel.string = (index + 1) + '.';

        for (let i = 0; i < taxonomy.reel; i++) {
            for (let j = 0; j < taxonomy.row; j++) {
                this.gphs.rect(i * (this.gap + this.tileSize), -j * (this.gap + this.tileSize), this.tileSize, -this.tileSize);
                if (data[i] === j) {
                    this.gphs.fillColor = cc.Color.RED;
                } else {
                    this.gphs.fillColor = cc.Color.WHITE;
                }
                this.gphs.fill();
            }
        }
        this.node.width = taxonomy.reel * this.tileSize  + (taxonomy.reel - 1) * this.gap;
        this.node.height = taxonomy.row * this.tileSize  + (taxonomy.row - 1) * this.gap;

        this.indexLabel.node.y = -this.node.height / 2 ;
    },
});
